/**
 * The localStorage name of the new-address dialog's unsaved draft.
 *
 * Its own module so the sign-out eraser (`app/browserData.ts`) can name it
 * without importing the dialog: the draft is catalog data a person typed —
 * an address, its chains, a name, a risk call — not a preference.
 */
export const NEW_ADDRESS_DRAFT_KEY = "new-address-draft-v1";
